import ModelInfoButton from "components/ui/customs/components/ModelInfoButton";

const BackofficeHome = (props) => {
  return <>Home Page - Backoffice</>;
};

export default BackofficeHome;
